import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = useSelector(
        (state) =>
            state.loginReducer.isAuthenticatedWithHybris ||
            JSON.parse(localStorage.getItem('userAuthenticated'))
    );
    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: '/login' }}></Redirect>
                )
            }
        />
    );
};

export default AuthenticatedRoute;
